import { render, staticRenderFns } from "./DialogIdeaScoreQuickTour.vue?vue&type=template&id=4334f916"
import script from "./DialogIdeaScoreQuickTour.vue?vue&type=script&lang=js"
export * from "./DialogIdeaScoreQuickTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports